import React from "react";
import { useInView } from "react-intersection-observer";
import "./ResumeSkillSection.css";

export default function ResumeSkillSection({ theme = "light" }) {
  const { ref, inView } = useInView({ threshold: 0.17, triggerOnce: true });

  return (
    <section ref={ref} className={`dual-hero-section theme-${theme} ${inView ? "in-view" : ""}`}>
      <div className="section-title-wrapper">
        <h2 className="section-title">
          LAND IN YOUR <span style={{ color: "#0f9ef0ff" }}>DREAM JOB</span>
        </h2>
      </div>
      <div className={`dual-hero-row${inView ? " in-view" : ""}`}>
        <div className="hero-content appear-left">
          <h3 className="hero-sub">AI Resume Builder</h3>
          <p className="hero-brief">
            Create a job-ready resume in minutes with AI.<br />
            Turn skills into your superpower.
          </p>
          <p className="hero-detail">
            Forget dull exams—our AI-powered skill tests are built to hype your strengths and spot what’s missing.
            Whether it’s coding, problem-solving, or communication, you get instant feedback that actually helps you grow.
            <br /><br />And the best part? Your results become proof of what you can do.
            No more “trust me, I know this.” With every test, you’re leveling up, showing the world you’re job-ready, and standing out where it matters most.
          </p>
          <button className="hero-btn">Create my CV</button>
        </div>
        <div className="hero-image appear-right">
          <img src="\assets\readytocrackjob.jpeg" alt="AI Resume Builder" />
        </div>
      </div>
      <div className={`dual-hero-row reverse${inView ? " in-view" : ""}`}>
        <div className="hero-content appear-right">
          <h3 className="hero-sub">Ready to crack job</h3>
          <p className="hero-brief">
            Ready for every skills test with AI.<br />AI prep = jobs unlocked
          </p>
          <p className="hero-detail">
            Some random content. Prepare for every skill challenge with instant insights and feedback.
            Our AI is designed to help you unlock real opportunities, not just pass another test.
            Stand out, get noticed, and land the job you deserve.
          </p>
          <button className="hero-btn">Take skill test</button>
        </div>
        <div className="hero-image appear-left">
          <img src="\assets\airesumebuilder.jpeg" alt="AI Skill Test" />
        </div>
      </div>
    </section>
  );
}
